// #region Dependencias
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledImage = styled.img`
  display: block;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  user-select: none;
  width: 100%;
`

const StyledLabel = styled.label`
  height: 100%;
  width: 100%;
  ${({ modoEdicion }) =>
    modoEdicion &&
    `
    cursor: pointer;
    &:hover {
      box-shadow: 0px 0px 0px 2px ${colors.secondary};
    }
  `}
`

const StyledInput = styled.input`
  display: none;
`
// #endregion

/**
 * Componente para renderizar un <input /> de archivos con la previsualización de una imagen.
 *
 * @class
 * @example
 * <InputImagePreview name="imagen" src={imagen} alt="imagen" modoEdicion={true} />
 *
 * @param {boolean} props.modoEdicion - Valor que indica si el componente se encuentra en modo edición para permitir el cambio de imágen.
 * @param {string} props.name - Nombre del input donde se guarda el valor seleccionado.
 * @param {string} props.src - Atributo 'src' de la imagen del componente.
 * @param {string} props.alt - Atributo 'alt' de la imagen del componente.
 */
const InputImagePreview = ({ modoEdicion, name, src, alt, ...props }) => {
  return (
    <>
      <StyledLabel htmlFor={name} modoEdicion={modoEdicion}>
        <StyledImage src={src} alt={alt || src} {...props} />
        {modoEdicion && (
          <StyledInput
            alt={alt}
            accept={['.jpg', '.jpeg', '.png', '.gif']}
            disabled={false}
            id={name}
            name={name}
            type="file"
            {...props}
          />
        )}
      </StyledLabel>
    </>
  )
}

export default InputImagePreview
